import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { JobWorkEntity } from "./job-work-entity";
import { JobWorkController } from "./job-work-controller";
import { JobWorkService } from "./job-work-service";

@Module({
    imports: [
        TypeOrmModule.forFeature([JobWorkEntity]),
    ],
    controllers: [JobWorkController],
    providers: [JobWorkService, ApplicationExceptionHandler]
})
export class JobWorkModule {

}